const alertData = [
  { icon: "speed", title: "Over Speed", path: "/notification-logs", color: "error" },
  { icon: "pause_circle", title: "Idle", path: "/journey-reports", color: "warning" },
  { icon: "stop_circle", title: "Halt", path: "/vehicle-reports", color: "secondary" },
  { icon: "report_problem", title: "Panic", path: "/distance-reports", color: "primary" },
  { icon: "report_problem", title: "Ignition", path: "/distance-reports", color: "error" },
  { icon: "car_crash", title: "Harsh Breaking", path: "/cachement-Dashboard", color: "dark" },
  { icon: "turn_slight_right", title: "Harsh Corner", path: "/attendance-Reports", color: "success" },
  { icon: "trending_up", title: "Harsh Acceleration", path: "/attendance-Reports", color: "info" },
  { icon: "settings_backup_restore", title: "Device Pull Out", path: "/attendance-Reports", color: "warning" },
  { icon: "signal_wifi_off", title: "No Response", path: "/attendance-Reports", color: "error" },
];

export default alertData;
